import React, { Component, Fragment } from 'react';
import { Input, Icon } from 'antd';

import './Search.css';
import { inject, observer } from 'mobx-react';
import { MagnifierIcon } from 'air-icons';

@inject('translationsStore', 'carsStore')
@observer
export default class Search extends Component {
  constructor(props) {
    super(props);
    const { carsStore } = this.props;
    this.state = {
      textToSearch: carsStore.searchQuery || ''
    };
  }

  search = () => {
    const { carsStore } = this.props;
    const { textToSearch } = this.state;
    // carsStore.search(textToSearch);

    this.virtualSearch(textToSearch);
  };

  resetSearch = () => {
    const { carsStore } = this.props;
    const textToSearch = '';
    this.setState({ textToSearch });
    // carsStore.search();

    this.virtualSearch(textToSearch);
  };

  virtualSearch = textToSearch => {
    const { carsStore } = this.props;
    window.localStorage.setItem(carsStore.cacheKey, 1);
    carsStore.setVirtualQuery(textToSearch);
    carsStore.virtualLoad();
  };

  onTextSearchChange = e => {
    this.setState({ textToSearch: e.target.value });
  };

  emitEmpty = () => {
    this.resetSearch();
  };

  keyPress = e => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  render() {
    const { translationsStore, carsStore } = this.props;
    const { textToSearch } = this.state;
    const suffix = textToSearch ? <Icon type="close-circle" onClick={this.emitEmpty} /> : <Fragment />;

    return (
      <div className="Search">
        <Input
          style={{ width: '350px' }}
          value={textToSearch}
          onKeyDown={this.keyPress}
          suffix={suffix}
          name="fulltextsearch"
          onChange={this.onTextSearchChange}
          placeholder={translationsStore.translate('search.placeholder')}
          prefix={<MagnifierIcon onClick={this.search} style={{ cursor: 'pointer' }} />}
        />
      </div>
    );
  }
}
